import { ComponentNameEnum } from '@/types';

interface PositionGridOptions {
  defaultValue?: string;
  allowCenter?: boolean;
}

const getPositionGridFieldConfig = (defaultValue = 'bl', options: PositionGridOptions = {}) => ({
  componentName: ComponentNameEnum.POSITION_GRID,
  options: {
    defaultValue,
    ...options,
  },
});

export default getPositionGridFieldConfig;
